module.exports = __webpack_public_path__ + "img/enuma-logo.8512280e.png";